module.exports = __webpack_public_path__ + "img/submit-button.632df78c.png";